import './style.scss';

import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { withRouter } from 'react-router-dom';
import Header from '../header';
import Footer from '../footer';
import SideNav from '../sideNav';
import { hideCart } from '../cart/actions';
import { applyAppScroll, APP_CONTAINER_ID } from '../app/actions';
import AsyncCartPreview from 'components/cart/asyncPreview';
import { isSmallScreen } from 'shared/utils';
import { slideoutPanel } from '../sideNav/styles.mod.scss';
import useScrollableHeader from './useScrollableHeader';
import styles from './styles.mod.scss';

function AppWrapper({ children, location, renderHeader, footerProps = {} }) {
  const dispatch = useDispatch();

  const cartOpen = useSelector(state => state.cart.show);

  const headerRef = useRef();
  const appContainerRef = useRef();

  const [isScrollingDown, setIsScrollingDown] = useScrollableHeader({
    headerElement: headerRef.current,
    scrollableElement: cartOpen ? appContainerRef.current : null
  });

  // reset header when page changes
  useEffect(() => {
    setIsScrollingDown(false);
  }, [location, setIsScrollingDown]);

  // restore previous scroll position when cart state changes
  useEffect(() => {
    dispatch(applyAppScroll());
  }, [cartOpen, dispatch]);

  function closeCart(e) {
    const isButton = e.target.nodeName === 'BUTTON';
    const isLink = e.target.nodeName === 'A';
    if (cartOpen && !isButton && !isLink) {
      dispatch(hideCart());
    }
  }

  const panelRef = useRef();
  const toggleRef = useRef();

  const onHeaderClick = isSmallScreen() ? () => dispatch(hideCart()) : null;

  return (
    <>
      <main ref={panelRef} className={slideoutPanel}>
        {renderHeader ? (
          renderHeader({
            cartOpen,
            isScrollingDown,
            headerRef,
            toggleRef,
            onClick: onHeaderClick
          })
        ) : (
          <Header
            cartOpen={cartOpen}
            isScrollingDown={isScrollingDown}
            headerRef={headerRef}
            toggleRef={toggleRef}
            onClick={onHeaderClick}
          />
        )}

        <div
          id={APP_CONTAINER_ID}
          className={classnames(styles.appContainer, {
            [styles.appContainerCartOpen]: cartOpen,
            [styles.appContainerScrollingDown]: isScrollingDown
          })}
          onClick={closeCart}
          ref={appContainerRef}
        >
          {children}
          <Footer {...footerProps} />
        </div>

        <TransitionGroup>
          {cartOpen && (
            <CSSTransition
              key="cart-preview-container"
              classNames="cart-preview-container"
              timeout={300}
            >
              <div className="cart-preview-container">
                <AsyncCartPreview />
              </div>
            </CSSTransition>
          )}
        </TransitionGroup>
      </main>

      <SideNav panelRef={panelRef} toggleRef={toggleRef} />
    </>
  );
}

export default withRouter(AppWrapper);
